import { render, staticRenderFns } from "./QuizPlayer.vue?vue&type=template&id=676fc07d&"
import script from "./QuizPlayer.vue?vue&type=script&lang=ts&"
export * from "./QuizPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./QuizPlayer.vue?vue&type=style&index=0&id=676fc07d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports